import { tvpil } from '../compat/tvpil';

import { prefetchLogoQuery } from './queries';

type PrefetchLogoArgs = {
  referenceId: string;
};

export async function prefetchLogo({ referenceId }: PrefetchLogoArgs) {
  const category = tvpil.categoryTreeItemsMap.get(referenceId);

  if (!category) {
    return;
  }

  const collectionId = category.channels[0];
  const kSql = category.aggregatedKSQL;

  if (!collectionId) {
    return;
  }

  return prefetchLogoQuery({ collectionId, kSql, referenceId });
}
